// extracted by mini-css-extract-plugin
export default {"container":"RepatchInput_container__Nq5oJ","label":"RepatchInput_label__t22Y5","input":"RepatchInput_input__1kuq0"};